<!--
 * @Author: your name
 * @Date: 2021-08-10 01:28:02
 * @LastEditTime: 2022-03-02 00:45:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/views/Hint.vue
-->
<template>
  <OuterRing class="box">
    <div class="container">
      <p>您是否有如下资料：</p>
      <br />

      <p>
        1、孕妇外周血胎儿游离DNA产前检测（无创）报告：<b>（含首页、补充页）</b>
      </p>
      <p>
        2、羊水穿刺染色体检查报告<b
          >（如：染色体核型分析，染色体畸变检测-(CNV)，染色体高通量测序，染色体芯片分析，染色体荧光原位杂交技术(FISH)，QF-PCR）</b
        >
      </p>
      <p>
        3、羊水穿刺发票<b class="important"
          >（医院盖章，缴费凭证需兑换为发票，电子发票需要打印）</b
        >
      </p>
      <p>4、羊水穿刺费用清单</p>
      <p>5、参检孕妇本人的身份证</p>
      <p>6、参检孕妇本人的银行卡</p>
      <br />
      <b class="important">确保资料清晰、完整再上传</b>
    </div>
    <div class="operate">
      <van-button v-if="mandatory" type="info" disabled
        >{{ countdown }}s后可操作</van-button
      >
      <template v-else>
        <van-button type="info" @click="show = true"
          >未做检测/资料不全</van-button
        >
        <van-button class="btn-margin" type="info" @click="goNotice"
          >已有全部资料</van-button
        >
      </template>
    </div>
    <van-Dialog
      v-model="show"
      confirm-button-text="退出"
      confirm-button-color="#f1a705"
      @confirm="toHome"
      class="no-scroll"
      theme="round-button"
    >
      <div class="dialog-content">
        <p>请您务必认真阅读以下内容：</p>
        <br />
        <p>
          一、参检孕妇<b>（即参检者）</b>需在二级及以上公立医院<b>（不含特需和国际医疗部）</b>进行
          产前诊断；
        </p>
        <p>二、诊断完毕后，需要准备好如下材料： 您是否有如下资料：</p>
        <ul>
          <li>
            1、孕妇外周血胎儿游离DNA产前检测<b>（无创）</b>报告：
            <b>（含首页、补充页）</b>
          </li>
          <li>
            2、羊水穿刺染色体检查报告<b
              >（如：染色体核型分析，染色体畸变检测-(CNV)，染色体高通量测序，染色体芯片分析，染色体荧光原位杂交技术(FISH)，QF-PCR）</b
            >
          </li>
          <li>
            3、羊水穿刺发票<b
              >（医院盖章，缴费凭证需兑换为发票，电子发票需要打印）</b
            >
          </li>
          <li>4、羊水穿刺费用清单</li>
          <li>5、参检孕妇本人的身份证</li>
          <li>6、参检孕妇本人的银行卡</li>
        </ul>
        <br />
        <b class="important">请务必准备好以上资料再申请理赔</b>
      </div>
    </van-Dialog>
  </OuterRing>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      mandatory: true,
      countdown: 5,
    };
  },
  mounted() {
    this.countdownRuntime();
  },
  methods: {
    countdownRuntime() {
      const timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.mandatory = false;
        }
      }, 1000);
      // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
      this.$once("hook:beforeDestroy", () => {
        clearInterval(timer);
      });
    },
    toHome() {
      // eslint-disable-next-line no-undef
      WeixinJSBridge.call("closeWindow");
    },
    goNotice() {
      this.$router.push(`/claimMaterial/uploadBasic/10`);
    },
  },
};
</script>
<style lang="less">
.box {
  padding-bottom: 60px;
}
.container {
  font-size: 18px;
  text-align: left;

  p {
    margin: 0;
    padding: 0;

    margin-top: 12px;

    line-height: 24px;
  }
}

.important {
  color: #ee0a24;
}

.operate {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  .van-button {
    flex: 1;

    &:last-child {
      margin-left: 2px;
    }
  }
}

.dialog-content {
  margin: 8px;
  padding: 6px;
  height: 70vh;
  overflow-y: auto;
  font-size: 14px;

  ul {
    margin-left: 12px;

    line-height: 16px;

    li {
      margin-top: 8px;
    }
  }
}
</style>
